// extracted by mini-css-extract-plugin
export default {"container":"styles_container__Oh1t8","form-container":"styles_form-container__n9Pg1"};